export enum DocumentState {
  EMPTY = 'EMPTY',
  IN_PROGRESS = 'IN_PROGRESS',
  SUBMITTED = 'SUBMITTED',
  ACCEPTED = 'ACCEPTED'
}
